"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var testing_utils_exports = {};
__export(testing_utils_exports, {
  getMockConfig: () => getMockConfig,
  getMockContext: () => getMockContext,
  inMemoryContext: () => inMemoryContext
});
module.exports = __toCommonJS(testing_utils_exports);
var import_path = __toESM(require("path"), 1);
var import_getReactNavigationConfig = require("./getReactNavigationConfig");
var import_getRoutes = require("./router/getRoutes");
var validExtensions = [
  ".js",
  ".jsx",
  ".ts",
  ".tsx"
];
function inMemoryContext(context) {
  return Object.assign(function(id) {
    id = id.replace(/^\.\//, "").replace(/\.\w*$/, "");
    return typeof context[id] === "function" ? {
      default: context[id]
    } : context[id];
  }, {
    resolve: function(key) {
      return key;
    },
    id: "0",
    keys: function() {
      return Object.keys(context).map(function(key) {
        var ext = import_path.default.extname(key);
        key = key.replace(/^\.\//, "");
        key = key.startsWith("/") ? key : `./${key}`;
        key = validExtensions.includes(ext) ? key : `${key}.js`;
        return key;
      });
    }
  });
}
function getMockContext(context) {
  if (Array.isArray(context)) {
    return inMemoryContext(Object.fromEntries(context.map(function(filename) {
      return [
        filename,
        {
          default: function() {
            return null;
          }
        }
      ];
    })));
  }
  throw new Error("Invalid context");
}
function getMockConfig(context) {
  var metaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return (0, import_getReactNavigationConfig.getReactNavigationConfig)((0, import_getRoutes.getRoutes)(getMockContext(context)), metaOnly);
}
//# sourceMappingURL=testing-utils.js.map
